import React from "react";
import DOMPurify from "dompurify";


const HtmlRenderer = ({ html }) => {
    const sanitizedHtml = DOMPurify.sanitize(html);
    return (
        <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
    );
}


export default HtmlRenderer;